import React from 'react';
import { useIntl } from 'react-intl';
import { Transition } from 'react-transition-group';
import type { BetslipDefault } from '@gin-betting/betslip';
import type { App } from '@gin-betting/core';
import cn from 'classnames';
import 'rxjs/add/observable/fromEvent';

import { Icon } from 'components';
import UserDevice from 'services/user-device';
import messages from '../../../messages';
import SettingsPopup from './SettingsPopup';
import useUpdateSettings from './useUpdatesSettings';

import settingsIcon from 'assets/svg/setting-betslip.svg';
import './updatesSettings.scss';

const transitionStyles: any = {
    entering: { opacity: 0 },
    entered: { opacity: 1 },
    exiting: { opacity: 0 },
    exited: { opacity: 0 },
};

interface Props {
    changeOddUpdateStatus: BetslipDefault['actions']['changeOddUpdateStatus'];
    oddUpdateStatus: App.OddUpdateStatus;
}

const UpdatesSettings: React.FC<Props> = ({
    oddUpdateStatus: activeOddUpdateStatus,
    changeOddUpdateStatus,
}) => {
    const { togglePopup, hasOpenedPopup } = useUpdateSettings();
    const { formatMessage } = useIntl();

    return (
        <React.Fragment>
            <div
                styleName={cn('icon-wr', {
                    'is-mobile': UserDevice.getInstance()?.isDeviceMobile(),
                })}
            >
                <Icon
                    styleName={cn('icon', {
                        'is-highlighted': hasOpenedPopup,
                    })}
                    glyph={settingsIcon}
                    onClick={togglePopup}
                    title={formatMessage(messages.oddsUpdates)}
                />
            </div>
            <Transition
                in={hasOpenedPopup}
                timeout={{
                    enter: 0,
                    exit: 500,
                }}
                unmountOnExit={true}
                appear={true}
            >
                {stateTransition => {
                    return (
                        <div
                            styleName="transition-animation"
                            style={{
                                ...transitionStyles[stateTransition],
                            }}
                        >
                            <SettingsPopup
                                changeOddUpdateStatus={changeOddUpdateStatus}
                                activeOddUpdateStatus={activeOddUpdateStatus}
                            />
                        </div>
                    );
                }}
            </Transition>
        </React.Fragment>
    );
};

export default UpdatesSettings;
